import { hasUnfitProblem2 as hasUnfitProblem } from '../../../../utils/lookahead-common';
import { findDeepGetActivityOfTask } from '../../../../views/lookahead/planification/index.helper';
import { isGrouped } from '../../GanttVisualization.helper';
import { getClassOdd, setUpModificationRequest } from './utils';
import { renderContentEndDate, renderIfNotTask } from './templates';

const renderEnd = ({
  task,
  onlyRead,
  column,
  setModalModification,
  modalModification,
  t
}) => {
  const isOnlyReadElement = onlyRead || task?.readonly;

  /** No Render if parent is Abstract */
  const shouldRenderEmptySpan = () => isGrouped() && task?.type === null;
  if (shouldRenderEmptySpan()) return null;

  /** Check if data is defined. Activity don't have this data */
  const notTaskResult = renderIfNotTask(task, column);
  if (notTaskResult) return notTaskResult;

  /** get activity reference */
  const activityReference = findDeepGetActivityOfTask(
    window.activities,
    'id',
    task?.id
  );
  if (!activityReference) return '';

  /** this function intercepts the save call, and adds data */

  /**
   * This function handles the request acitivity modification
   * @param {*} task task which has problems of unfit dates
   * @param {*} activity activity to request modification
   */
  const handleActivityModificationRequest = (task, activity) => {
    setModalModification({
      ...modalModification,
      visible: true,
      title: t('modals.lookahead.activity_modification_request.title'),
      data: {
        task,
        activity
      }
    });
  };

  const hasItUnfitYup = hasUnfitProblem(
    task,
    activityReference,
    isOnlyReadElement,
    t
  );

  const classOdd = getClassOdd(task, column);
  const taskDate = task?.end_date;

  setUpModificationRequest({
    onlyRead,
    task,
    activityReference,
    handleActivityModificationRequest
  });

  return renderContentEndDate({ classOdd, taskDate, hasItUnfitYup });
};

export default renderEnd;
